<template>
    <div class="d-flex" style="height: 100%;">
      <div class="w-50">
        <v-container class="popup-container main-container">
          <v-row class="popup-container row-container">
            <div class="center-h pt-0">
              <v-content>
                <v-card fill-height class="improve-login-card">
                  <v-img
                    class="center-v login-logo hover-cursor"
                    src="static/improve-logo.png"
                    @click="openInNewTab()"
                  ></v-img>
                  <v-card-text class="center-v partner-login-form">
                    <p class="partner-login-label center-v">Log in</p>
                    <br />
                    <div style="font-size: 16px;">
                      Need an IMPROVE account?
                      <router-link to="/signup">Create an account</router-link>
                    </div>
                    <v-spacer></v-spacer>
                    <v-alert
                      class="mt-8 text-center"
                      v-if="errMsg"
                      :value="alert"
                      color="#ffcbcb"
                      ><b> Login failed </b>
                      <p>Please Check your sign in details and try again</p>
                    </v-alert>
                    <div class="mt-8 parnter-login">
                      <span
                        >Are you a Partner?
                        <a style="color: #ff00009e !important;" :href="$globalConfig.PARTNER_URL"
                          >Log in here</a
                        ></span
                      >
                    </div>
                    <div class="label mt-4">Email:</div>
                    <v-text-field
                      v-model="email"
                      type="text"
                      placeholder="johnsmith@email.com"
                      outlined
                      required
                      class="input"
                      @keyup.enter="login"
                    ></v-text-field>
                    <div class="label mt-7">Password:</div>
                    <v-text-field
                      v-model="password"
                      placeholder="*******"
                      outlined
                      required
                      class="input"
                      :append-icon="showInput ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showInput ? 'text' : 'password'"
                      @click:append="toggleInputVisibility"
                      @keyup.enter="login"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                  </v-card-text>
                  <v-card-text class="forgot_password mr-auto ml-auto">
                    <span>
                      By logging into Improve you agree to our <br />
                      <a
                        @click.prevent="toggleCheckboxState(privacyPolicyLink)"
                        href="#"
                        >Privacy Policy</a
                      >
                      and
                      <a
                        @click.prevent="toggleCheckboxState(termsConditionsLink)"
                        href="#"
                        >Terms and Conditions</a
                      >
                    </span>
                  </v-card-text>
                  <v-card-actions class="center-v login-btn">
                    <v-btn v-if="loading" color="primary" loading></v-btn>
                    <v-btn
                      v-else
                      color="primary"
                      class="login-button"
                      @click.prevent="login"
                      >Login</v-btn
                    >
                  </v-card-actions>
                  <v-card-text class="center-v forgot_password">
                    <router-link class="" to="/forgot-password"
                      >Forgot Password</router-link
                    >
                  </v-card-text>
  
                  <v-flex class="mt-4 pa-4 center-v">
                      <v-card-text class="login-frm">
                        <v-btn @click="loginWithSSO('Microsoft')" class="sso-btn input" x-large>
                          <div class="icon">
                          <img src="/static/microsoft-logo.svg" alt="#" class="mr-5">
                          </div>
                          <img src="/static/sso-vertical-seperator.png" alt="#" class="mr-3">
                          <span class="login-text">Login with Microsoft</span>
                        </v-btn>
                        <v-btn @click="loginWithSSO('Google')" class="sso-btn input google-btn" x-large>
                          <div class="icon">
                          <img src="/static/google-logo.svg" alt="#" class="mr-5">
                          </div>
                          <img src="/static/sso-vertical-seperator.png" alt="#" class="mr-3">
                          <span class="login-text">Login with Google</span>
                        </v-btn>
                      </v-card-text>
                    </v-flex>
                </v-card>
              </v-content>
            </div>
          </v-row>
        </v-container>
      </div>
      <div class="login-background-img"></div>
      <div>
        <img
          src="static/improve-login-screen-mobile-image.png"
          class="login-center-img"
          align="center"
        />
      </div>
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'DirectLogin',
    data: () => ({
      password: '',
      email: '',
      valid: true,
      loading: false,
      messages: {
        email: [],
        password: [],
        error: [],
      },
      isChecked: false,
      privacyPolicyLink: 'https://www.improve.online/privacy-policy/',
      termsConditionsLink: 'https://www.improve.online/eula/ ',
      alert: true,
      errMsg: '',
      showInput: false,
    }),
    methods: {
      openInNewTab: function()
      {
         window.open(this.$globalConfig.FRONTEND_URL, '_blank');
      },
      login: function() {
        this.loading = true;
        this.$store
          .dispatch('login', {
            email: this.email,
            password: this.password,
          })
          .then((resp) => {
              this.getProfile();
          })
          .catch((err) => {
            this.loading = false;
            this.valid = false;
            this.messages = [];
            let errors = err.response.data.errors;
            // this.errMsg = err.response.data.message;
            // if (this.errMsg) {
            //   this.errMsg = errors != null && errors.email && errors.email[0].search("The selected email is invalid.") != 0 ? errMsg : "The email/password combination entered was incorrect. Please check your credentials and try again."
            //   this.errorMessage = this.errMsg;
            // }
            if (err.response.status == 401) {
              this.errMsg =
                '<b> Login failed </b> <p> Please Check your sign in details and try again </p>';
            } else if (err.response.status == 500) {
              this.$snotify.error(err.response.data.message);
            }
            if (errors) {
              for (let field in errors) {
                this.messages[field] = errors[field];
              }
            }
          });
      },
      getProfile() {
        this.$store
          .dispatch('profile')
          .then((resp) => {
            switch (this.$store.getters.level) {
              case 1:
                this.$router.push('/super-admin/companies');
                break;
              case 2:
                this.$router.push('admin/users');
                break;
              case 7:
                this.$router.push('/course-library');
                break;
              case 8:
                this.$router.push('/invoicing-admin/companies');
                break;
              default:
                this.$router.push('/courses');
                break;
            }
          })
          .catch((err) => {
            // Auth succeeded but loading the profile genuinely failed (network / 5xx).
            // Don't strand the user silently on the login screen — surface it so they can retry.
            this.loading = false;
            this.$snotify.error('You are signed in, but we could not load your account. Please try again, and contact support if this continues.');
          });
      },
      toggleCheckboxState(link) {
        window.open(link, '_blank'); // Open the link in a new tab
        // this.isChecked = !this.isChecked; // Toggle the checkbox state
      },
      toggleInputVisibility() {
        this.showInput = !this.showInput;
      },
      loginWithSSO(provider) {
        let url = this.$globalConfig.SSO_URL + '/' + provider.toLowerCase();
        window.open(url, "_self")
      },
    },
  };
  </script>
  <style>
  .v-alert {
    color: #4f0e0e !important;
  }
  
  .v-alert__content p {
    margin: 0 !important;
  }
  
  .hover-cursor {
      cursor: pointer; /* or any other type of cursor you prefer */
  }
  
  .sso-btn {
    padding-top: 27px !important;
    padding-bottom: 27px !important;
    width: 320px;
    height: 56px;
    display: flex;
    justify-content: flex-start;
    color: #333333;
    font-size: 18px;
    background: transparent !important;
    height: 56px;
    border: 1px solid #c4c4c4 !important;
    text-transform: none;
    letter-spacing: 0;
    margin: 0;
  }
  .sso-btn .icon{
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 25px;
    margin-right: 15px;
    max-width: 25px;
    min-width: 25px;
  }
  .sso-btn .icon img{
    width: 100%;
    height: 25px;
  }
  .login-text {
    flex: 1;
    text-align: left;
  }
  </style>
  